"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeTx = exports.safeFromPopulated = exports.multisendTx = exports.MULTI_SEND_ADDR = void 0;
const ethers_1 = require("ethers");
const kasumah_wallet_1 = require("kasumah-wallet");
const signer_1 = require("./signer");
const debug_1 = __importDefault(require("debug"));
const log = debug_1.default("GnosisHelpers");
exports.MULTI_SEND_ADDR = "0x8D29bE29923b68abfDD21e541b9374737B49cdAD";
async function multisendTx(txs) {
    return kasumah_wallet_1.encodeMultiSend(txs);
}
exports.multisendTx = multisendTx;
async function safeFromPopulated(safe, nonce, userSigner, userWalletAddr, to, data, operation, isLedger, overrides) {
    let value = ethers_1.constants.Zero;
    if (overrides && overrides.hasOwnProperty("value")) {
        value = ethers_1.BigNumber.from(await overrides.value);
    }
    const sig = await signer_1.signer(safe, userSigner, userWalletAddr, to, value, data, operation, 0, 0, 0, ethers_1.constants.AddressZero, ethers_1.constants.AddressZero, nonce, !!isLedger);
    const execArgs = [
        to,
        value.toHexString(),
        data,
        operation,
        0,
        0,
        0,
        ethers_1.constants.AddressZero,
        ethers_1.constants.AddressZero,
        sig,
    ];
    let txArgs = [...execArgs];
    if (overrides) {
        delete overrides.value;
        txArgs.push(overrides);
    }
    return [await safe.populateTransaction.execTransaction(...txArgs), execArgs];
}
exports.safeFromPopulated = safeFromPopulated;
async function safeTx(safe, nonce, userSigner, userWalletAddr, to, funcName, ...args) {
    log(`sign ${funcName} on ${to.address}: `, ...args);
    const populatedTx = await to.populateTransaction[funcName](...args);
    if (!populatedTx.data) {
        throw new Error("populating returned no data");
    }
    let override = undefined;
    const lastArg = args[args.length - 1];
    if (lastArg.gasLimit || lastArg.value) {
        override = lastArg;
    }
    return safeFromPopulated(safe, nonce, userSigner, userWalletAddr, to.address, populatedTx.data, kasumah_wallet_1.OPERATION.CALL, false, override);
}
exports.safeTx = safeTx;
